export var CARD_ACTIVATION_ELIGIBILITY_URL = "v1/credit/cards/activate";
//# sourceMappingURL=endpoints.js.map